<template slot-scope="scope">
  <!-- 绑定/更换银行卡 -->

      <dialogModel
        title="权限编辑"
        :visible="dialogEDITOR"
        @handleClose="handleCancelEDITOR"
        @handleOk="handleVerifyEDITOR"
      >
        <div class="dialog-content">
            <!-- <div class="content">
              <div class="content-tit TypeSize">{{ echoRow.username }}</div>
              <div class="content-box TypeSize">{{ echoRow.phone }}</div>
            </div> -->
            <div class="name-telephone">
              <div class="name-p">
                {{ echoRow.username }}
              </div>

              <div class="telephone-p">{{ echoRow.phone }}</div>
            </div>
            <div class="content content-Position">
              <div class="content-tit"><span style="color: red">*</span>职位：</div>
              <div class="content-box">
                <el-select
                  v-model="ruleForm.positionEnumId"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="content">
              <div class="content-tit">
                <span style="color: red">*</span>权限配置：
              </div>
              <div class="content-box">
                <div
                  class="ipt-container-for"
                  v-for="(item, index) in TypeArr"
                  :key="index"
                >
                  <div
                    :class="
                      ruleForm.action == item.id
                        ? 'Select-div'
                        : 'notSelect-div'
                    "
                    @click="handelClick(item)"
                  ></div>
                  <div>{{ item.name }}</div>
                </div>
              </div>
            </div>
            <!-- 可看页面勾选 -->
            <div
              class="check-content"
              v-for="(item, index) in listArr"
              :key="index"
            >
              <div class="checkRegion firm-clickable" @click="handelClickSwitch(index, item)">
                <div class="checkRegion-content">
                  <!-- 父级复选框添加点击事件 -->
                  <el-checkbox
                    v-model="item.disabled"
                    @change="handleParentCheckChange(item)"
                  ></el-checkbox>
                  <div class="page-name">{{ item.label }}</div>
                  <div class="icon"></div>
                </div>
              </div>
              <div class="unfold" v-if="item.fields == '1'">
                <div
                  class="unfold-box"
                  v-for="(item1, index1) in item.children"
                  :key="index1"
                >
                  <!-- 子级复选框添加点击事件 -->
                  <el-checkbox
                    v-model="item1.disabled"
                    @change="handleChildCheckChange(item)"
                  ></el-checkbox>
                  <div class="page-name">{{ item1.label }}</div>
                </div>
              </div>
            </div>
          </div>
      </dialogModel>
</template>

<script>
import {
  getCompanyMenuTree, // 获取公司菜单
  adminPermissions, //获取企业管理员权限列表
  saveOrUpdateAdminPermissions, //添加企业管理员权限列表
} from "../../../../../assets/api/firm/firmCenter";
export default {
  props: {
    dialogEDITOR: {},
    echoRow: {}, // 数据回显
    arr: {},
  },
  components: {},
  data() {
    return {
      ruleForm: {
        value: "",
      }, //v-model
      options: [
        {
          label: "总经理(总裁)", //职位名
          value: 0, //id
        },
        {
          label: "总经理", //职位名
          value: 1, //id
        },
        {
          label: "人力资源总监", //职位名
          value: 2, //id
        },
        {
          label: "财务总监(CFO)", //职位名
          value: 3, //id
        },
        {
          label: "销售总监", //职位名
          value: 4, //id
        },
        {
          label: "市场总监（CMO）", //职位名
          value: 5, //id
        },
        {
          label: "生产总监", //职位名
          value: 6, //id
        },
        {
          label: "运营总监", //职位名
          value: 7, //id
        },
        {
          label: "技术总监(CTO)", //职位名
          value: 8, //id
        },
        {
          label: "总经理助理", //职位名
          value: 9, //id
        },
        {
          label: "人力资源", //职位名
          value: 10, //id
        },
        {
          label: "人力资源助理", //职位名
          value: 11, //id
        },
        {
          label: "人力资源专员", //职位名
          value: 12, //id
        },
        {
          label: "招聘主管", //职位名
          value: 13, //id
        },
        {
          label: "客服主管", //职位名
          value: 14, //id
        },
        {
          label: "客服助理", //职位名
          value: 15, //id
        },
      ], //职位选择
      TypeArr: [
        { name: "可操作", id: "1" },
        { name: "只可查看", id: "0" },
      ], // 发票类型
      SelectType: "0", // 发票类型选中
      listArr: [],
    };
  },
  watch: {
    // 监听父组件传过来的数据
    dialogEDITOR: {
      handler(newSs, old) {
        // 监听弹窗的开关 获取刷新用户数据
        // 拷贝加弹窗开关监听从新赋值数据是为防止选择数据后不进行操作关闭弹窗，再次打开弹窗数据还是上次操作后的数据
        this.ruleForm = JSON.parse(JSON.stringify(this.echoRow)); //拷贝
      },
      immediate: false,
    },
    arr: {
      handler(newSs, old) {
        getCompanyMenuTree().then((res) => {
          if (res.code === 0) {
            // 第一次循环：根据 newSs 设置子节点的 disabled
            for (var i in res.data) {
              // 确保 children 存在且是数组
              const children = res.data[i].children || [];
              for (var k in children) {
                for (var s in newSs) {
                  if (children[k].label === newSs[s]) {
                    children[k].disabled = true;
                  }
                }
              }
            }

            // 第二次循环：【修改这里】只要有一个子级选中，父级就选中
            for (var i in res.data) {
              const children = res.data[i].children || [];
              const hasAnyChildDisabled = children.some(
                (child) => child.disabled === true
              );
              if (hasAnyChildDisabled) {
                res.data[i].disabled = true;
              }
            }

            this.listArr = res.data;
            // 强制更新视图，确保父级勾选状态显示
            this.$forceUpdate();
          }
        });
      },
      immediate: false,
    },
  },
  computed: {},
  created() {
    // 获取公司菜单
    this.getCompanyMenuTree();
  },
  destroyed() {},
  methods: {
    // 父级复选框变更事件
    handleParentCheckChange(item) {
      const children = item.children || [];
      // 父级选中/取消时，同步所有子级的状态
      children.forEach((child) => {
        child.disabled = item.disabled;
      });
    },
    // // 子级复选框变更事件
    // handleChildCheckChange(item) {
    //   const children = item.children || [];
    //   // 检查所有子级是否都被选中
    //   const allSelected = children.every(child => child.disabled === true);
    //   // 更新父级状态
    //   item.disabled = allSelected;
    // },
    // 子级复选框变更事件
    handleChildCheckChange(item) {
      const children = item.children || [];
      // 只要有一个子级被选中，父级就选中（原来的逻辑是全部选中才选中）
      const hasAnySelected = children.some((child) => child.disabled === true);
      item.disabled = hasAnySelected;
    },
    // 获取公司菜单
    getCompanyMenuTree() {
      getCompanyMenuTree().then((res) => {
        if (res.code == 0) {
          this.listArr = res.data;
        }
      });
    },
    // 只打开一个菜单
    handelClickSwitch(index, item) {
      if (item.fields == "1") {
        item.fields = null;
      } else {
        item.fields = "1";
      }
    },
    // 权限配置选择
    handelClick(item) {
      this.ruleForm.action = item.id;
      this.SelectType = item.id;
    },
    //取消关闭
    handleCancelEDITOR() {
      for (var i in this.listArr) {
        // 确保 children 存在
        const children = this.listArr[i].children || [];
        for (var k in children) {
          children[k].disabled = false;
        }
        // 同时重置父级选中状态
        this.listArr[i].disabled = false;
      }
      this.$emit("handleCancelEDITOR");
    },
    // 编辑确认
    handleVerifyEDITOR() {
      if (!this.$checkAction()) return;
      if (
        this.ruleForm.positionEnumId === "" ||
        this.ruleForm.positionEnumId === null ||
        this.ruleForm.positionEnumId === undefined
      ) {
        this.$tool.PromptBox("warning", "请选择职位");
        return;
      }
      if (
        this.ruleForm.action === "" ||
        this.ruleForm.action === null ||
        this.ruleForm.action === undefined
      ) {
        this.$tool.PromptBox("warning", "请选择权限配置");
        return;
      }
      // 获取选中的code数组
      var arr = [];
      for (var i in this.listArr) {
        const children = this.listArr[i].children || [];
        for (var k in children) {
          if (children[k].disabled == true) {
            arr.push(children[k].code);
          }
        }
      }
      var data = {
        data: {
          action: this.ruleForm.action, //0看 1操作
          menuIds: arr,
          bindId: this.ruleForm.bindId,
          positionEnumId: this.ruleForm.positionEnumId,
        },
      };
      saveOrUpdateAdminPermissions(data).then((res) => {
        if (res.code == 0) {
          this.$tool.PromptBox("success", "操作成功");
          this.$emit("handleVerifyEDITOR");
        } else {
          this.$emit("handleVerifyEDITOR");
        }
        for (var i in this.listArr) {
          const children = this.listArr[i].children || [];
          for (var k in children) {
            children[k].disabled = false;
          }
          // 重置父级选中状态
          this.listArr[i].disabled = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
// 选择框的大小
/deep/.el-checkbox__inner {
  width: 15px;
  height: 15px;
  margin-top: 2px;
  border: 1px solid #409eff ;
}
// 表单验证
/deep/.el-form-item {
  margin-bottom: 0px;
  // height: 35px;
}
/deep/.el-date-editor {
  position: relative !important;
}
/deep/.el-form-item__content {
  margin-left: 0 !important;
}

/deep/.el-input__inner {
  //   width: 250px;
  height: 35px !important;
  border: 1px solid #409eff ;
}
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  div {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.dialog-content {
    width: 550px;
    min-height: 35px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    .name-telephone {
      width: 100%;
      display: flex;
      font-size: 15px;
      color: #333333;
      margin-bottom: 20px;
      .name-p {
        max-width: 360px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .telephone-p {
        margin-left: 50px;
      }
    }
    .content {
      width: 100%;
      height: 35px;
      line-height: 35px;
      display: flex;
      margin-bottom: 20px;
      .content-tit {
        width: 80px;
        height: 35px;
        font-family: PingFangSC-Medium;
        font-size: 14px;
        color: #333333;
        text-align: right;
        font-weight: 400;
      }
      .TypeSize {
        font-size: 18px;
      }
      .content-box {
        flex: 1;
        height: 35px;
        margin-left: 10px;
        display: flex;
        .ipt-container-for {
          display: flex;
          margin-right: 30px;
        }
        .notSelect-div {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          margin: auto 0;
          margin-right: 10px;
          background-image: url("../../../../../assets/imgs/weigouxuan@3x.svg");
          background-size: 100% 100%;
          cursor: pointer;
        }
        .Select-div {
          width: 18px;
          height: 18px;
          border-radius: 50%;
          margin: auto 0;
          margin-right: 10px;
          background-image: url("../../../../../assets/imgs/gouxuan@3x.svg");
          background-size: 100% 100%;
          cursor: pointer;
        }
      }
    }
    .content-Position {
      width: 400px;
    }
    // 勾选可看
    .check-content {
      width: 100%;
      min-height: 50px;
      //   margin-bottom: 20px;
      .checkRegion {
        width: 510px;
        height: 40px;
        padding: 0px 20px 0px 20px;
        background: #ffffff;
        border: 1px solid #409eff ;
        box-shadow: 0px 2px 4px 0px rgba(153, 153, 153, 0.5);
        border-radius: 5px;
        margin-top: 5px;
        display: flex;
        .checkRegion-content {
          width: 100%;
          height: 18px;
          line-height: 18px;
          margin: auto;
          display: flex;
          position: relative;
        }
        .page-name {
          margin-left: 10px;
          font-family: PingFangSC-Medium;
          font-size: 16px;
          color: #333333;
          font-weight: 400;
        }
        .icon {
          width: 20px;
          height: 11.5px;
          position: absolute;
          right: 0;
          top: 3px;
          background-image: url("../../../../../assets/imgs/jiantou-xia@3x.svg");
          background-size: 100% 100%;
        }
      }
      .unfold {
        width: 490px;
        padding: 20px 20px 0px 20px;
        min-height: 20px;
        background: #eeeeee;
        border-radius: 0px 0px 5px 5px;
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;

        .unfold-box {
          min-width: 60px;
          height: 18px;
          line-height: 18px;
          display: flex;
          margin-right: 20px;
          margin-bottom: 20px;
          .page-name {
            margin-left: 10px;
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
        }
      }
    }
}
/deep/.el-button {
  width: 120px !important;
  height: 40px !important;
}
.el-button--primary {
  background: #409eff ;
  border: 1px solid #409eff ;
}
</style>
